<template>

    <m-edit1/>

    <m-single-product-202 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard200","relatedCourse":false,"galleryFullSlider":false},...{}}' :style='""' class="" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                
                <template #p-3>   <m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr><m-content-slider-4 v-bind='{...{"cardLink":false,"contentCategory":["single-pro-card"],"contentType":"page","slicer":null,"itemClass":"col-lg-4 my-2","waitForCategoryProp":true,"categoryColumnProp":"slug","contentCard":"mContentCard515","sliderPagination":true,"swiperPerViewSM":1,"swiperPerViewMD":2,"swiperPerViewLG":4,"swiperPerViewSpaceBetweenSM":30,"swiperPerViewSpaceBetweenMD":30,"swiperPerViewSpaceBetweenLG":30,"sliderGridStatus":false,"sliderGridRows":2,"sliderLoop":false,"contentDirectLinkOn":false},...{}}' :style='""' class="" ></m-content-slider-4></template>
                </m-single-product-202>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct202 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct202/SingleProduct202'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr'; import mContentSlider4 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider4';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct202,mHr,mContentSlider4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
